import { useEffect, useRef } from "react";
import { Toaster, toast } from "sonner";
import { BookOpen } from "lucide-react";

const BUYERS = [
    ["Rohan", "Mumbai"],
    ["Ishita", "Delhi"],
    ["Karthik", "Hyderabad"],
    ["Meera", "Chennai"],
    ["Arjun", "Pune"],
    ["Fatima", "Lucknow"],
];

// Gentle "recent purchase" nudges — capped so they never spam
export default function PurchaseToasts() {
    const shown = useRef(0);

    useEffect(() => {
        const AGES = ["2 min ago", "6 min ago", "11 min ago"];
        const show = () => {
            if (shown.current >= 6 || document.hidden) return;
            const [name, city] =
                BUYERS[Math.floor(Math.random() * BUYERS.length)];
            const age = AGES[Math.floor(Math.random() * AGES.length)];
            toast.custom(
                () => (
                    <div
                        data-testid="recent-purchase-toast"
                        className="flex items-center gap-3 rounded-2xl border border-emerald-100 bg-white/95 px-4 py-3 shadow-lift backdrop-blur-md"
                    >
                        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50 text-emerald-600">
                            <BookOpen size={16} />
                        </span>
                        <span className="text-xs">
                            <span className="block font-semibold text-slate-900">
                                {name} from {city}
                            </span>
                            <span className="block text-slate-500">
                                just purchased the bundle · {age} 🔥
                            </span>
                        </span>
                    </div>
                ),
                { duration: 4500 },
            );
            shown.current += 1;
        };

        const first = setTimeout(show, 6000);
        const interval = setInterval(show, 22000);
        return () => {
            clearTimeout(first);
            clearInterval(interval);
        };
    }, []);

    return (
        <Toaster position="bottom-left" offset={100} visibleToasts={1} />
    );
}
